var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('div',{staticClass:"main-navigation"},[_c('div',{staticClass:"logo logo-centered"},[_c('router-link',{attrs:{"to":'/'}},[_c('img',{attrs:{"width":"320","height":"","src":_vm.iconLogo.src}})])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }